import React from 'react';
import { authenticationRoute } from '@/modules/core/auth/route';
import { createRoute } from '@tanstack/react-router';

export const loginRoute = createRoute({
  getParentRoute: () => authenticationRoute,
  path: 'login',
  component: React.lazy(async () => await import('@/containers/SignInContainer')),
  wrapInSuspense: true,
});
